var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _dec5, _dec6, _dec7, _dec8, _dec9, _class2, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogMemberFactory from "../../Models/Catalog/CatalogMemberFactory";
import modelReferenceTrait from "../Decorators/modelReferenceTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
export let BaseMapTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Image",
  description: "Path to the basemap image"
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Contrast color",
  description: "Color which should be used to contrast with basemap (eg for region mapping feature borders)"
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Background color",
  description: "Background color to use for the map container when showing this base map. This setting is currently only applicable in Leaflet or 2D mode. It is useful when the base map does not cover the entire screen and a background color matching the overall base map style is desired."
}), _dec4 = modelReferenceTrait({
  factory: CatalogMemberFactory,
  name: "Base map item",
  description: 'Catalog item definition to be used for the base map. It is also possible to reference an existing catalog item using its id (i.e. `"//Surface Geology"`).'
}), _class = class BaseMapTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "image", _descriptor, this);
    _initializerDefineProperty(this, "contrastColor", _descriptor2, this);
    _initializerDefineProperty(this, "backgroundColor", _descriptor3, this);
    _initializerDefineProperty(this, "item", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "image", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "contrastColor", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "#ffffff";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "backgroundColor", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "item", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let BaseMapsTraits = (_dec5 = primitiveTrait({
  type: "string",
  name: "defaultBaseMapId",
  description: "The id of the baseMap user will see on the first mapLoad. This wil be used **before** `defaultBaseMapName`"
}), _dec6 = primitiveTrait({
  type: "string",
  name: "defaultBaseMapName",
  description: "Name of the base map to use as default"
}), _dec7 = primitiveTrait({
  type: "string",
  name: "previewBaseMapId",
  description: "The id of the baseMap to be used as the base map in data preview. "
}), _dec8 = objectArrayTrait({
  type: BaseMapTraits,
  idProperty: "item",
  name: "items",
  description: "Array of catalog items definitions that can be used as a Base map."
}), _dec9 = primitiveArrayTrait({
  type: "string",
  name: "enabledBaseMaps",
  description: "Array of base maps ids that is available to user. Use this do define order of the base maps in settings panel. Leave undefined to show all basemaps."
}), _class2 = class BaseMapsTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "defaultBaseMapId", _descriptor5, this);
    _initializerDefineProperty(this, "defaultBaseMapName", _descriptor6, this);
    _initializerDefineProperty(this, "previewBaseMapId", _descriptor7, this);
    _initializerDefineProperty(this, "items", _descriptor8, this);
    _initializerDefineProperty(this, "enabledBaseMaps", _descriptor9, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "defaultBaseMapId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "defaultBaseMapName", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "previewBaseMapId", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "basemap-natural-earth-II";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "items", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "enabledBaseMaps", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);